import { decode } from '../helpers/decode_env';

function createFileRecord(formInfo, postFileUploadData, source, status){
    const az_container_name = process.env.REACT_APP_BACKEND_AZURE_CONTAINER_NAME ? decode(process.env.REACT_APP_BACKEND_AZURE_CONTAINER_NAME) : '';  
    formInfo['fileLocationPath'] = postFileUploadData.fileUrl.split(`${az_container_name}/`)[1];
    formInfo['fileSize'] = postFileUploadData.fileSize
    formInfo['fileCheckSum'] = postFileUploadData.fileCheckSum;
    formInfo['docType'] = source;
    if(status) formInfo['status'] = status;
    delete formInfo['file'];

    return formInfo;
}

export default createFileRecord;